module.exports = "images/doc-cotation-add-2.f5353c4697cbba130c559e46b7519b24.png";